import React from 'react';
import { Box, InputBase, Paper, IconButton } from '@material-ui/core';

import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';

const CommonSearchBar = React.memo(({ value, onChange, placeholder = 'Search...', width = 320 }) => {
  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" mb={1}>
      <Paper
        elevation={1}
        style={{
          display: 'flex',
          alignItems: 'center',
          width,
          padding: '2px 10px',
          borderRadius: 10,
          border: '1px solid #e0e0e0',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        }}>
        <SearchIcon
          style={{
            color: '#9e9e9e',
            fontSize: 20,
            marginRight: 6,
          }}
        />

        <InputBase
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          fullWidth
          style={{
            fontSize: '0.9rem',
          }}
        />

        {value && (
          <IconButton
            size="small"
            onClick={() => onChange('')}
            style={{
              padding: 4,
              marginLeft: 4,
            }}>
            <ClearIcon
              style={{
                fontSize: 18,
                color: '#9e9e9e',
              }}
            />
          </IconButton>
        )}
      </Paper>
    </Box>
  );
});

export default CommonSearchBar;
